/* ==========================================================================
   RK Tunes - consolidated custom JS
   Replaces the inline <script> blocks that used to live in layout/theme.liquid.
   Load with `defer` so the DOM is ready when this runs.
   ========================================================================== */
(function () {
  'use strict';

  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;

  /* ------------------------------------------------------------------------
     Shared scroll dispatcher
     One passive listener, rAF-throttled. Previously there were three separate
     unthrottled scroll listeners fighting each other.
     ------------------------------------------------------------------------ */
  var scrollHandlers = [];
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var y = window.scrollY;
      for (var i = 0; i < scrollHandlers.length; i++) {
        try { scrollHandlers[i](y); } catch (e) {}
      }
      ticking = false;
    });
  }

  function addScrollHandler(fn) {
    scrollHandlers.push(fn);
    if (scrollHandlers.length === 1) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ------------------------------------------------------------------------
     1. Trust badges + "use the dropdowns" prompt
     ------------------------------------------------------------------------ */
  function initTrustBadges() {
    var apps = document.querySelector('.shopify-section-group-header-group.shopify-section--apps');
    if (!apps || document.getElementById('rk-trust-badges')) return;

    var badges = document.createElement('div');
    badges.id = 'rk-trust-badges';
    badges.innerHTML =
      '<div class="rk-trust-row">' +
        '<div class="rk-trust-item"><div class="rk-trust-icon">\uD83D\uDE9A</div><div class="rk-trust-label">Free Shipping</div><div class="rk-trust-sub">USA Orders</div></div>' +
        '<div class="rk-trust-item"><div class="rk-trust-icon">\uD83D\uDD27</div><div class="rk-trust-label">Designed In-House</div><div class="rk-trust-sub">Real Engineering</div></div>' +
        '<div class="rk-trust-item"><div class="rk-trust-icon">\uD83D\uDCAC</div><div class="rk-trust-label">Direct Support</div><div class="rk-trust-sub">Talk to Us</div></div>' +
      '</div>';
    apps.parentNode.insertBefore(badges, apps);

    var boxWrapper = document.createElement('div');
    boxWrapper.className = 'rk-search-box-wrapper';
    var box = document.createElement('div');
    box.id = 'rk-search-box';
    box.innerHTML = '<p>\u2B06\uFE0F Use the dropdowns above to find parts for your car \u2B06\uFE0F</p>';
    boxWrapper.appendChild(box);
    apps.appendChild(boxWrapper);
  }

  /* ------------------------------------------------------------------------
     2. Collapsible YMM (Select Your Vehicle) toggle
     Was completely dead - two stray closing braces caused a SyntaxError.
     Also replaced the 1-second setInterval poll with change events.
     ------------------------------------------------------------------------ */
  function initYmmToggle() {
    var appSection = document.querySelector('.shopify-section-group-header-group.shopify-section--apps');
    if (!appSection || document.getElementById('rk-ymm-toggle')) return;

    var toggle = document.createElement('div');
    toggle.id = 'rk-ymm-toggle';
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML =
      '\uD83D\uDE97 <span class="rk-ymm-label">Select Your Vehicle</span> ' +
      '<span class="rk-ymm-selected"></span> <span class="rk-ymm-arrow">\u25BC</span>';
    appSection.parentNode.insertBefore(toggle, appSection);

    var searchBox = document.getElementById('rk-search-box');

    function collapse() {
      toggle.classList.remove('rk-open');
      toggle.setAttribute('aria-expanded', 'false');
      appSection.style.display = 'none';
      if (searchBox) searchBox.style.display = 'none';
    }

    function expand() {
      toggle.classList.add('rk-open');
      toggle.setAttribute('aria-expanded', 'true');
      appSection.style.display = '';
      if (searchBox) searchBox.style.display = '';
    }

    if (isProductPage) { collapse(); } else { expand(); }

    function toggleOpen() {
      if (toggle.classList.contains('rk-open')) { collapse(); } else { expand(); }
    }

    toggle.addEventListener('click', toggleOpen);
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleOpen(); }
    });

    function refreshLabel() {
      var selects = appSection.querySelectorAll('select');
      var selected = [];
      Array.prototype.forEach.call(selects, function (s) {
        if (s.value && s.value.toLowerCase().indexOf('select') === -1) selected.push(s.value);
      });
      var selectedEl = toggle.querySelector('.rk-ymm-selected');
      var labelEl = toggle.querySelector('.rk-ymm-label');
      if (selected.length >= 2) {
        selectedEl.textContent = '\u2014 ' + selected.join(' ');
        labelEl.textContent = 'Your Vehicle';
      } else {
        selectedEl.textContent = '';
        labelEl.textContent = 'Select Your Vehicle';
      }
    }

    appSection.addEventListener('change', refreshLabel);
    new MutationObserver(refreshLabel).observe(appSection, { childList: true, subtree: true });
    refreshLabel();
  }

  /* ------------------------------------------------------------------------
     3. Hide header on scroll down, reveal on scroll up
     Was rebuilding className with string replace, wiping other classes.
     ------------------------------------------------------------------------ */
  function initHeaderHide() {
    var header = document.querySelector('.shopify-section-group-header-group');
    if (!header) return;

    var lastY = window.scrollY;

    addScrollHandler(function (y) {
      if (y > 100 && y > lastY) {
        header.classList.add('header-hidden');
      } else {
        header.classList.remove('header-hidden');
      }
      lastY = y;
    });
  }

  /* ---------------------------------------------------------------------- */
  function init() {
    initTrustBadges();
    initYmmToggle();
    initHeaderHide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
